export default Object.freeze({
    Principal: "principal",
    Producer: "producer",
    Csr: "csr",
    BranchManager: "branch-manager",
    AuthorizedAppointmentRep: "authorized-appointment-rep",
    OtherEmployee: "other-employee"
});